import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import type { ComponentProps } from 'react';

export const Checkbox = ({
  className,
  ...props
}: ComponentProps<typeof CheckboxPrimitive.Root>) => (
  <CheckboxPrimitive.Root
    data-slot="checkbox"
    className={cn(
      'peer border-brand-medium-gray data-[state=checked]:bg-brand-purple data-[state=checked]:border-brand-purple focus-visible:border-brand-focus focus-visible:ring-brand-focus transition-background size-5 shrink-0 rounded-sm border outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      data-slot="checkbox-indicator"
      className="flex items-center justify-center text-current transition-none"
    >
      <CheckIcon className="size-3.5 [&_path]:stroke-white" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);
